module.exports = __webpack_public_path__ + "static/key-voidbastards-4493cfabb04cb4371bce9ca3cb24f422.webp";